module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_header_camera-41e818c0a85f020665ca4c65cb288a95.svg";